// src/components/Leaderboard.js
import React from 'react';
import Avatar from './Avatar'; 
import pointsIcon from '../assets/points_icon.png';
export default function Leaderboard({ data }) {
  return (
    <div className="leaderboard-container card">
      <h3>Таблица лидеров</h3>
      <ol className="leaderboard-list">
        {data.map((user, index) => (
          <li key={user.userId} className="leaderboard-item">
            <span className="leaderboard-rank">{index + 1}</span>
            <Avatar 
  user={{ id: user.userId, username: user.username, avatar: user.avatar }} 
  className="leaderboard-avatar" 
/>
            <span className="leaderboard-name">{user.username}</span>
            <span className="leaderboard-points">{user.totalPoints} <img src={pointsIcon} alt="сезонные очки" className="points-icon seasonal-icon" title="Сезонные очки" /></span>
          </li>
        ))}
      </ol>
    </div>
  );
}